<template>
  <modal-default
    ref="modal"
    :title="title"
    :short-circuit-close="true"
    @close="cancel"
  >
    <form-field-datetime-picker
      v-model="nextContactValue"
      is-inline
      is-clearable
    ></form-field-datetime-picker>

    <div class="flex flex-vertical-center flex-between">
      <button-outlined
        @click="setNextContact(1)"
        color="is-secondary"
        is-short
      >One Hour
      </button-outlined>

      <button-outlined
        @click="setNextContact(24)"
        color="is-secondary"
        class="ml-50"
        is-short
      >Tomorrow
      </button-outlined>

      <button-outlined
        @click="setNextContact(24*7)"
        color="is-secondary"
        class="ml-50"
        is-short
      >Next Week
      </button-outlined>

      <button-outlined
        @click="setNextContact(24*30)"
        color="is-secondary"
        class="ml-50"
        is-short
      >Thirty Days
      </button-outlined>
    </div>

    <template v-slot:footer>
      <button-default @click="cancel">Cancel</button-default>
      <button-default @click="confirmed">Confirm</button-default>
    </template>
  </modal-default>
</template>

<script>
import ModalBase from "./ModalBase";
import {destroyModal} from "../../services/modals";

export default {
  name: "PromptNextContactModal",
  components: {ModalBase},
  props: {
    title: {
      type: String,
      default: "Select Next Contact Date"
    },
    record: {
      type: Object,
      required: true
    },
  },
  data() {
    return {
      nextContactValue: null,
    };
  },
  mounted() {
    this.$refs.modal.open();
    this.setNextContact(24);
  },
  methods: {
    setNextContact(hours) {
      let currentDate = new Date();
      currentDate.setHours(currentDate.getHours() + hours);
      this.nextContactValue = currentDate;
    },
    confirmed() {
      this.$emit("confirmed", this.nextContactValue);
      destroyModal(this.$refs.modal);
    },
    cancel() {
      this.$emit("canceled");
      destroyModal(this.$refs.modal);
    },
  }
};
</script>
